import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteConfig } from '@/mocks/siteData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
      role="navigation"
      aria-label="主导航"
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 group"
            aria-label="返回首页"
          >
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight transition-colors duration-300 ${
              scrolled ? 'text-primary-600' : 'text-white'
            }`}>
              {siteConfig.logo}
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`whitespace-nowrap px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                    isActive
                      ? scrolled
                        ? 'bg-primary-50 text-primary-600'
                        : 'bg-white/20 text-white'
                      : scrolled
                        ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                        : 'text-white/80 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <button
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white border border-white/30 hover:bg-white/30'
              }`}
            >
              <i className="ri-search-line mr-1.5"></i>
              搜索
            </button>
            <Link
              to="/about"
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white text-primary-600 hover:bg-white/90'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={mobileOpen}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden fixed inset-0 top-16 bg-white z-40 transition-transform duration-300 ${
          mobileOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col p-4 gap-1 overflow-y-auto h-full">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href;
            return (
              <Link
                key={link.href}
                to={link.href}
                className={`whitespace-nowrap px-4 py-3 rounded-lg text-base font-medium transition-colors cursor-pointer ${
                  isActive
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
          <div className="border-t border-background-200 mt-3 pt-3 flex flex-col gap-2">
            <button className="whitespace-nowrap w-full px-4 py-3 rounded-full text-sm font-medium bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer text-left">
              <i className="ri-search-line mr-2"></i>搜索视频
            </button>
            <Link
              to="/about"
              className="whitespace-nowrap w-full px-4 py-3 rounded-full text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer text-center block"
            >
              关于我们
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}